export default "__VITE_ASSET__6586b394__"